import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bigNumber'
})
export class BigNumberPipe implements PipeTransform {
  transform(number: any, args?: any): any {
    if (!number) {
      return 0;
    }

    if (number >= 1000000) {
      return Math.floor(number / 1000000) + 'm';
    } else if (number >= 100000) {
      return (number / 1000000).toFixed(1) + 'm';
    } else if (number >= 10000) {
      return Math.floor(number / 1000) + 'K';
    } else if (number >= 1000) {
      return (number / 1000).toFixed(1) + 'K';
    } else {
      return number;
    }
  }
}
